import * as ActionUtility from '@utilities/action-utility'
import { createCompanyEffect } from './onboarding-effects'

const REQUEST_CREATE_COMPANY = 'Aberto.Onboarding.REQUEST_CREATE_COMPANY'
const REQUEST_CREATE_COMPANY_FINISHED = 'Aberto.Onboarding.REQUEST_CREATE_COMPANY_FINISHED'

const createRequest = async state => {
  const { onboarding } = state

  const companyStep = onboarding.companyStep.company
  const legalResponsibleStep = onboarding.legalResponsibleStep
  const addressStep = onboarding.addressStep.address

  let logo

  var getLogo = async () =>
    new Promise(resolve => {
      fetch(companyStep.brand)
        .then(res => res.blob())
        .then(blob => {
          blob.name = companyStep.fileName
          resolve(blob)
        })
    })

  if (companyStep.brand) logo = await getLogo()

  const company = {
    id: companyStep.cnpj,
    name: companyStep.companyName,
    tradingName: companyStep.companyAlias,
    category: companyStep.category,
    logo,
    hasPhysicalStore: companyStep.physicalStore,
    hasECommerce: companyStep.virtualStore,
    acceptTermsAndCondition: companyStep.optinRegulation,
    termsAndConditionVersion: onboarding.companyStep.regulation.version,
    managerName: legalResponsibleStep.fullName,
    managerIdentifier: legalResponsibleStep.cpf,
    managerCellPhoneNumber: legalResponsibleStep.cellPhone,
    managerEmail: legalResponsibleStep.email,
    street: addressStep.street,
    number: addressStep.number,
    complement: addressStep.addressComplement,
    city: addressStep.city,
    district: addressStep.district,
    uf: addressStep.uf,
    zipCode: addressStep.zipCode,
    latitude: addressStep.latitude,
    longitude: addressStep.longitude,
    ...onboarding.securityStep,
  }
  return { company, fileName: companyStep.fileName }
}

const createCompany = () => {
  return async (dispatch, getState) => {
    const { company, fileName } = await createRequest(getState())
    return await ActionUtility.createThunkEffect(dispatch, REQUEST_CREATE_COMPANY, createCompanyEffect, company, fileName)
  }
}

export { createCompany, REQUEST_CREATE_COMPANY, REQUEST_CREATE_COMPANY_FINISHED }
